// extracted by mini-css-extract-plugin
export default {"articlesList":"ArticlesList_articlesList__ujg7o","error":"ArticlesList_error__UiVwB"};